import { useEffect, useState } from "react";
import { DeviceMobile, Bank, Money } from "@phosphor-icons/react";
import { api, usd, fmtDate, STATUS_META } from "@/lib/api";
import { StatusPill } from "@/components/common";
import { PageHead } from "./Properties";

const Stat = ({ label, value, testId }) => (
  <div className="rounded-2xl border border-border bg-white p-5"><p className="label-xs text-muted-foreground">{label}</p><p className="mt-2 font-display text-3xl" data-testid={testId}>{value}</p></div>
);

export default function Subscription() {
  const [d, setD] = useState(null);
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/subscription").then((r) => setD(r.data)); api.get("/pricing").then((r) => setS(r.data)); }, []);
  if (!d || !s) return null;
  const sub = d.subscription;
  return (
    <div data-testid="subscription-page">
      <PageHead eyebrow="Billing" title="Subscription"><StatusPill meta={STATUS_META[sub.status]} testId="subscription-status-pill" /></PageHead>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <Stat label="Trial days left" value={sub.status === "trial" ? sub.trial_days_left : "—"} testId="sub-trial-days" />
        <Stat label="Airbnbs billed" value={sub.properties} testId="sub-properties" />
        <Stat label="Monthly fee" value={usd(sub.monthly_fee)} testId="sub-monthly-fee" />
        <Stat label="Paid up to" value={sub.paid_until ? fmtDate(sub.paid_until) : "Not yet"} testId="sub-paid-until" />
      </div>
      <div className="mt-8 grid gap-6 lg:grid-cols-12">
        <section className="rounded-2xl bg-[#151312] p-7 text-white lg:col-span-7" data-testid="payment-instructions">
          <h2 className="font-display text-2xl">How to pay</h2>
          <p className="mt-2 text-white/70">{usd(s.price)} per Airbnb per month. {sub.status === "trial" && `Your trial ends ${fmtDate(sub.trial_ends)}.`} If a payment is late you have a {s.grace_days}-day grace period before your guest pages pause.</p>
          <div className="mt-6 grid gap-3 sm:grid-cols-3">{[[DeviceMobile, "MTN MoMo"], [DeviceMobile, "Airtel Money"], [Bank, "Bank transfer"]].map(([I, l]) => <div key={l} className="rounded-xl bg-white/5 p-4"><I size={22} className="text-[#E4A853]" /><p className="mt-2 text-sm font-semibold">{l}</p></div>)}</div>
          <p className="mt-6 whitespace-pre-line rounded-xl border border-white/10 p-4 text-sm leading-relaxed text-white/85">{s.pay_instructions}</p>
        </section>
        <section className="rounded-2xl border border-border bg-white p-6 lg:col-span-5">
          <h2 className="flex items-center gap-2 font-display text-xl"><Money /> Payment history</h2>
          <div className="mt-4 divide-y divide-border" data-testid="payment-history">
            {d.payments.length === 0 && <p className="py-4 text-sm text-muted-foreground">No payments recorded yet.</p>}
            {d.payments.map((p) => <div key={p.payment_id} className="flex justify-between py-3 text-sm"><div><p className="font-semibold">{usd(p.amount)} · {p.months} month{p.months > 1 ? "s" : ""}</p><p className="text-xs text-muted-foreground">{p.method}{p.ref ? ` · ${p.ref}` : ""}</p></div><span className="text-muted-foreground">{fmtDate(p.created_at)}</span></div>)}
          </div>
        </section>
      </div>
    </div>
  );
}
